export default {
  USERS_LIST: "Users List",
  ADD_USER: "Add User",
  USER_ADDED: "User Added",
  IS_STAFF: "Admin",
  ALL_IS_STAFF: "All Types",
  AUTHORIZATIONS: "Authorizations",
  EDIT_USER: "Edit User",
  USER_UPDATED: "User Updated",
  DELETE_THIS_USER: "Delete this user?",
  USER_DELETED: "User Deleted",
  ACTIVE: "Active",
  ACTIVATE: "Activate",
  DEACTIVATE: "Deactivate",
  USER_ACTIVATED: "User Activated",
  USER_DEACTIVATED: "User Deactivated",
  RESTRICT_TO_LOCATIONS: "Restrict to Locations",
  RESTRICT_TO_SERVICE_CENTERS: "Restrict to Service Centers",
  RESTRICT_TO_ESTABLISHMENTS: "Restrict to Establishments",
  RESTRICT_TO_CAFETERIAS: "Restrict to Cafeterias",
  TWO_FACTOR_AUTHENTICATION: "Two-Factor Authentication (2FA)",
  ENABLED: "Enabled",
  DISABLED: "Disabled",
  ENABLE_2FA: "Enable 2FA",
  DISABLE_2FA: "Disable 2FA",
  TWO_FA_ENABLED_AT: "2FA Enabled At",
  TWO_FA_DISABLED_AT: "2FA Disabled At",
  CONFIRM_ENABLE_2FA_TITLE: "Enable Two-Factor Authentication?",
  CONFIRM_ENABLE_2FA_TEXT: "You will need to enter a verification code sent to your email each time you log in.",
  CONFIRM_DISABLE_2FA_TITLE: "Disable Two-Factor Authentication?",
  CONFIRM_DISABLE_2FA_TEXT: "Your account will be less secure without two-factor authentication.",
  TWO_FA_ENABLED_SUCCESS: "Two-factor authentication has been enabled successfully.",
  TWO_FA_ENABLED_SUCCESS_LOGOUT: "Two-factor authentication has been enabled successfully. You will be logged out and need to verify with a code on your next login.",
  TWO_FA_DISABLED_SUCCESS: "Two-factor authentication has been disabled successfully.",
};
